module.exports = __webpack_public_path__ + "static/img/water_4.3528fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/water_4.png
// module id = 367
// module chunks = 1